import gql from 'graphql-tag';

import { AccountFileReactionDetails } from '../fragments/reactions';

export const AccountFileReactionCreate = gql`
  mutation accountFileReactionCreate($input: AccountFileReactionCreateInput!) {
    accountFileReactionCreate(input: $input) {
      account_file_reaction {
        id
        photo {
          id
          account_file_reaction {
            ...AccountFileReactionDetails
          }
        }
        video {
          id
          account_file_reaction {
            ...AccountFileReactionDetails
          }
        }
      }
    }
  }
  ${AccountFileReactionDetails}
`;

export const AccountFileReactionDelete = gql`
  mutation accountFileReactionDelete($input: AccountFileReactionDeleteInput!) {
    accountFileReactionDelete(input: $input) {
      success
    }
  }
`;
